import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        setTimeout(() => {
            let items = this.el.querySelector('.m-story_content_txt').querySelectorAll('.word');
            if (items.length > 0) {
                this.tl = gsap.timeline({ paused: true });
                this.tl.to(
                    items,
                    { opacity: 1, duration: 0.8, ease: "none", stagger: 0.1 },
                );
            }
        }, 500);

        window.addEventListener('storyBgProgress', (e) => {
            this.el.style.setProperty('--story-progress', e.detail.progress);
        });

        window.addEventListener('storyContentProgress', (e) => {
            if (this.tl) {
                this.tl.progress(e.detail.progress);
            }
        });
    }

    init() {
    }
}
